<template>
  <svg
    :class="customStyle"
    viewBox="0 0 98 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3659_35365)">
      <path
        opacity="0.8"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.9144 11.1486C20.914 8.00458 21.8443 6.04708 22.7037 5.27533C25.0836 3.13933 28.3741 4.30183 29.0737 4.46833C31.5312 5.05483 30.7321 1.19533 32.8406 0.410829C34.2458 -0.111921 35.4014 0.527079 36.3083 2.32783C37.1112 0.647829 38.3347 -0.121671 39.9788 0.0155796C42.4454 0.223329 43.3085 8.51158 46.6978 6.69733C50.0879 4.88233 54.2438 4.46758 56.0191 7.16458C56.4028 7.74808 56.5498 6.84283 59.1597 3.75208C61.7695 0.660579 64.3718 -0.701421 69.7105 1.09858C72.1379 1.91608 74.1341 4.13233 75.7013 7.74658C75.7013 12.9051 79.5158 15.9591 87.1432 16.9063C98.5858 18.3276 89.704 30.5668 75.7013 34.1511C61.6979 37.7361 29.4581 39.6711 11.9629 30.6141C0.299331 24.5773 2.95055 18.0883 19.9144 11.1486Z"
        fill="url(#paint0_linear_3659_35365)"
      />
      <path
        d="M48.6047 56.7336C60.2568 56.7336 69.7026 54.5584 69.7026 51.8751C69.7026 49.1918 60.2568 47.0166 48.6047 47.0166C36.9527 47.0166 27.5068 49.1918 27.5068 51.8751C27.5068 54.5584 36.9527 56.7336 48.6047 56.7336Z"
        fill="url(#paint1_linear_3659_35365)"
      />
      <path
        opacity="0.675"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M84.2239 57.9373C68.3607 61.8958 14.2142 57.3681 8.45103 55.3003C5.64597 54.2931 3.11757 52.3993 0.866589 49.6183C0.614653 49.3074 0.456296 48.9318 0.409816 48.5351C0.363336 48.1384 0.430631 47.7367 0.603924 47.3765C0.777216 47.0162 1.04943 46.7121 1.38912 46.4992C1.7288 46.2863 2.12209 46.1735 2.52354 46.1736H97.1418C99.1055 51.3771 94.7996 55.2981 84.2239 57.9373Z"
        fill="url(#paint2_linear_3659_35365)"
      />
      <path
        d="M64.795 38.8543L57.5799 30.4603C57.4093 30.2601 57.1972 30.0988 56.9582 29.9875C56.7193 29.8761 56.459 29.8174 56.1951 29.8153H40.6809C40.1487 29.8153 39.6429 30.0583 39.2961 30.4603L32.0811 38.8543V43.4623H64.795V38.8543Z"
        fill="url(#paint3_linear_3659_35365)"
      />
      <path
        d="M62.751 43.6318L56.4361 36.3208C56.2834 36.1482 56.0952 36.0103 55.8842 35.9164C55.6732 35.8226 55.4444 35.7751 55.2133 35.777H41.6637C41.1986 35.777 40.744 35.969 40.441 36.3208L34.126 43.6318V47.6473H62.751V43.6318Z"
        fill="url(#paint4_linear_3659_35365)"
      />
      <path
        d="M64.795 48.743C64.795 49.3828 64.5055 49.958 64.0486 50.3435L63.9559 50.4185C63.5937 50.6917 63.1515 50.8392 62.697 50.8385H34.1798C33.9219 50.8385 33.6754 50.792 33.4478 50.7065L33.3347 50.6615C32.9616 50.4964 32.6447 50.2272 32.4222 49.8866C32.1997 49.546 32.0812 49.1485 32.0811 48.7423V38.9045H40.0183C40.895 38.9045 41.6014 39.6223 41.6014 40.493V40.5043C41.6014 41.3758 42.316 42.0785 43.1927 42.0785H53.6833C54.1047 42.0781 54.5088 41.9116 54.807 41.6154C55.1053 41.3193 55.2734 40.9176 55.2746 40.4983C55.2746 39.6238 55.9817 38.9045 56.8577 38.9045H64.7957L64.795 48.743Z"
        fill="url(#paint5_linear_3659_35365)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3659_35365"
        x1="50.6644"
        y1="27.7125"
        x2="50.6644"
        y2="-6.55011"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#DEDEDE"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#A9A9A9"
          stop-opacity="0.3"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3659_35365"
        x1="46.4063"
        y1="56.7336"
        x2="46.4063"
        y2="47.0166"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="white"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#96A1C5"
          stop-opacity="0.373"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3659_35365"
        x1="48.9993"
        y1="59.5074"
        x2="48.9993"
        y2="43.5502"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="white"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#919191"
          stop-opacity="0.15"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3659_35365"
        x1="48.438"
        y1="29.8153"
        x2="48.438"
        y2="35.9496"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1FEEEE" />
        <stop
          offset="1"
          stop-color="#128C8C"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3659_35365"
        x1="52.2585"
        y1="47.6473"
        x2="52.2585"
        y2="35.146"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop
          offset="1"
          stop-color="#50C9C9"
        />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3659_35365"
        x1="48.4384"
        y1="38.9045"
        x2="48.4384"
        y2="50.8385"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1FEEEE" />
        <stop
          offset="1"
          stop-color="#128C8C"
        />
      </linearGradient>
      <clipPath id="clip0_3659_35365">
        <rect
          width="98"
          height="60"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'EmptyDataIcon',

  props: {
    customStyle: {
      type: String,
      default: 'w-24 h-16',
    },
  },
}
</script>
